import { useEffect, useState } from "react"
import { router, useLocalSearchParams } from "expo-router"
import { useAddAnalysis } from "@/queries/analysis"
import { place } from "@/stores/analysisDataStore"
import FullScreenLoader from "@/components/loading/FullScreenLoader"
import PropertyEditModal from "@/components/analysis/modal/PropertyEditModal"
import type { PropertyType } from "@/generated/graphql"
import {
  analysisLoadingViewed,
  propertyNotFoundViewed,
} from "@/analytics/events/analyzer"
import { showErrorToast } from "@/components/toasts/AppToast"
import { setStatusBarStyle } from "@/stores/statusBarStyle"
import { $subjectPropertyWalkthroughDismissed } from "@/stores/walkThroughs"

export default function Place() {
  const { placeId } = useLocalSearchParams()
  const [loading, setLoading] = useState<boolean>(true)
  const [property, setProperty] = useState<PropertyType | null | undefined>()
  const addAnalysisMutation = useAddAnalysis()

  const createAnalysis = (beds?: number, baths?: number, area?: number) => {
    setLoading(true)
    addAnalysisMutation.mutate(
      {
        placeId: Array.isArray(placeId) ? placeId[0] : placeId,
        bedrooms: beds,
        bathrooms: baths,
        area,
      },
      {
        onSuccess: (data) => {
          const analysis = data.createAnalysis?.analysis
          const createdProperty = data.createAnalysis?.analysis
            ?.property as PropertyType

          // Check if this is the first manual analysis and walkthrough hasn't been dismissed
          const isFirstAnalysis = analysis?.isFirstManualAnalysis
          const walkthroughDismissed =
            $subjectPropertyWalkthroughDismissed.get()

          if (isFirstAnalysis && walkthroughDismissed === null) {
            $subjectPropertyWalkthroughDismissed.set(false) // Initialize to display walkthrough
          }

          if (analysis?.bedrooms && analysis?.bathrooms && analysis?.area) {
            router.replace(`/properties/${analysis.id}`)
          } else if (createdProperty) {
            setProperty(createdProperty)
            setLoading(false)
            propertyNotFoundViewed({
              propertyAddress: createdProperty.fullAddress,
            })
          }
        },
        onError: (err) => {
          console.error(err)
          showErrorToast({
            title: "Analysis Failed",
            message: err.message,
          })
          router.back()
        },
      }
    )
  }

  useEffect(() => {
    setStatusBarStyle("dark")
    analysisLoadingViewed()
    const storedPlace = place()
    if (
      (Array.isArray(placeId) ? placeId[0] : placeId) !== storedPlace?.placeId
    ) {
      // TODO: Refactor to not use side-loaded data
      console.error(
        "routed to /analyze/search/[placeId] without $storedPlace data"
      )
      router.replace("/analyzer")
    }
    createAnalysis()
  }, [])

  if (loading) {
    return (
      <>
        <FullScreenLoader dark={true}>
          Finding comps and calculating ARV...
        </FullScreenLoader>
      </>
    )
  }

  console.log("[placeId]", property)

  return (
    <PropertyEditModal
      street={property?.street || ""}
      cityStateZip={`${property?.city}, ${property?.state} ${property?.zipcode}`}
      onEditProperty={createAnalysis}
      isRequiredEdit={true}
      onClose={() => {
        router.back()
      }}
    />
  )
}
